import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoginPage = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showRecovery, setShowRecovery] = useState(false);
  const [recoveryLoading, setRecoveryLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    // Simple password check
    if (password === "Armory") {
      // Set login with 365 days expiration
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 365);
      
      localStorage.setItem("armory_authenticated", "true");
      localStorage.setItem("armory_auth_expiry", expirationDate.toISOString());
      
      toast.success("Welcome to The Armory!");
      onLogin();
    } else {
      toast.error("Password Incorrect");
      setPassword("");
    }
    
    setLoading(false);
  };

  const handlePasswordRecovery = async () => {
    setRecoveryLoading(true);
    try {
      await axios.post(`${API}/auth/password-recovery`);
      toast.success("Password recovery email sent to kta.jason1@gmail.com");
      setShowRecovery(false);
    } catch (error) {
      toast.error("Failed to send recovery email");
    } finally {
      setRecoveryLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2djhoNHYtOGgtNHptMCAxNnY4aDR2LThoLTR6bTAgMTZ2OGg0di04aC00em0tMTYtMzJ2OGg0di04aC00em0wIDE2djhoNHYtOGgtNHptMCAxNnY4aDR2LThoLTR6bS0xNi0zMnY4aDR2LThoLTR6bTAgMTZ2OGg0di04aC00em0wIDE2djhoNHYtOGgtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="relative z-10 flex flex-col items-center">
        {/* Logo */}
        <div className="mb-12">
          <img 
            src="https://i.imgur.com/OHQS3rb.png" 
            alt="The Armory - Strength & Speed" 
            className="h-32 w-auto"
          />
        </div>

        {/* Question */}
        <h1 className="text-4xl font-bold text-white mb-8" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          What is the Password
        </h1>

        {/* Password Form */}
        <form onSubmit={handleLogin} className="w-full max-w-md mx-4">
          <Input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-14 text-lg text-center bg-white/95 border-2 border-slate-300 focus:border-slate-500"
            autoFocus
            required
          />
          
          <Button 
            type="submit" 
            className="w-full h-14 text-lg mt-4 bg-slate-800 hover:bg-slate-700"
            disabled={loading}
          >
            {loading ? "Checking..." : "Submit"}
          </Button>

          <div className="text-center mt-6">
            <button
              type="button"
              onClick={() => setShowRecovery(true)}
              className="text-sm text-white/70 hover:text-white hover:underline"
            >
              Forgot your password?
            </button>
          </div>
        </form>
      </div>

      {/* Password Recovery Dialog */}
      <Dialog open={showRecovery} onOpenChange={setShowRecovery}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Mail size={20} />
              Password Recovery
            </DialogTitle>
            <DialogDescription>
              A password recovery email will be sent to the registered email address.
            </DialogDescription>
          </DialogHeader>
          
          <div className="py-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-blue-900">
                <strong>Recovery Email:</strong> kta.jason1@gmail.com
              </p>
              <p className="text-xs text-blue-700 mt-2">
                The password will be sent to this email address.
              </p>
            </div>
          </div>

          <DialogFooter className="gap-2">
            <Button 
              variant="outline" 
              onClick={() => setShowRecovery(false)}
              disabled={recoveryLoading}
            >
              Cancel
            </Button>
            <Button 
              onClick={handlePasswordRecovery}
              disabled={recoveryLoading}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {recoveryLoading ? "Sending..." : "Send Recovery Email"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default LoginPage;
